import { Aggregation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Aggregation';
import { EnumMultiplicity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumMultiplicity';
import { EnumRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';

export class AggregationExtend {
  public static Init(dto: Aggregation) {
    dto.relationshipType = EnumRelationshipType.Aggregation;
    dto.sourceMultiplicity = EnumMultiplicity.ZeroOne;
    dto.targetMultiplicity = EnumMultiplicity.ZeroMany;
  }
}
